import { createAsyncThunk } from '@reduxjs/toolkit';

import * as livekit from 'endpoints/live-kit';
import { ApiResponse } from 'endpoints/endpoint';
import { apiRequest } from 'client/utils';

export const updatePermissions = createAsyncThunk<
  ApiResponse<livekit.UpdatePermissionsResult, livekit.UpdatePermissionsError>,
  livekit.UpdatePermissionsParams,
  { rejectValue: string }
>('livekit/updatePermissions', async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest<
      livekit.UpdatePermissionsParams,
      livekit.UpdatePermissionsResult,
      livekit.UpdatePermissionsError
    >(livekit.updatePermissions, {
      retries: true,
      data,
    })();

    if (response.success) {
      return response;
    }

    throw new Error('UpdatePermissionsError');
  } catch (e) {
    return rejectWithValue((e as Error).message);
  }
});
